export default "__VITE_ASSET__BQsGsQhE__"